export type TMAdjustmentId = string;

export enum TMAdjustmentType {
  category = 'category',
  fee = 'fee',
}

/** One change of a Summary tab adjustment (a category or a fee) with its note. Never edited or deleted. */
export interface TMAdjustmentResponse {
  id: TMAdjustmentId;
  type: TMAdjustmentType;
  /** The category or fee name (a fee's history is kept by its name) */
  name: string;
  oldAmount: number;
  newAmount: number;
  note: string;
  createdAt: number;
  user: TMAdjustmentUserResponse;
}

export interface TMAdjustmentUserResponse {
  id: string;
  name: string;
}

/** Summary tab: a category's new adjustment with the required note */
export interface TMCategoryAdjustmentRequest {
  adjustmentAmt: number;
  note: string;
}

/** Summary tab: a fee's new adjustment with the required note */
export interface TMFeeAdjustmentRequest {
  adjustmentAmount: number;
  note: string;
}
